import config from '@/config';

export const LocalStorageService = {
  get(key: string): any {
    const item = localStorage.getItem(`${config.LOCAL_STORAGE_PREFIX}${key}`);
    try {
      return item ? JSON.parse(item) : item;
    } catch (e) {
      return null;
    }
  },
  set(key: string, item: object): boolean {
    let isOK = false;
    if (item && typeof item === 'object') {
      const str = JSON.stringify(item);
      localStorage.setItem(`${config.LOCAL_STORAGE_PREFIX}${key}`, str);
      isOK = true;
    }
    return isOK;
  },
  remove(key: string) {
    localStorage.removeItem(`${config.LOCAL_STORAGE_PREFIX}${key}`);
  }
};
